
import React, { useEffect, useState, useCallback } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { tokenService } from '@/services/payment';
import { Coins } from 'lucide-react';

export const CreditBalance = () => {
  const { currentUser } = useAuth();
  const [balance, setBalance] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  const loadBalance = useCallback(async () => {
    if (currentUser) {
      try {
        setLoading(true);
        const tokens = await tokenService.getTokenBalance(currentUser.uid);
        setBalance(tokens.available);
      } catch (error) {
        console.error('Error loading credit balance:', error);
      } finally {
        setLoading(false);
      }
    }
  }, [currentUser]);

  useEffect(() => {
    loadBalance();
    
    // Set up a listener to refresh balance after a payment
    const handlePaymentSuccess = () => {
      console.log('[CreditBalance] Payment success event received, reloading balance');
      loadBalance();
    };
    
    window.addEventListener('payment-success', handlePaymentSuccess);
    
    return () => {
      window.removeEventListener('payment-success', handlePaymentSuccess);
    };
  }, [loadBalance]);

  if (!currentUser) return null;

  return (
    <div className="flex items-center gap-2 px-4 py-2 bg-purple-500/10 rounded-lg">
      <Coins className="h-5 w-5 text-purple-500" />
      <div className="flex flex-col">
        <span className="text-sm font-medium">Credits</span>
        <span className="text-lg font-bold">{loading ? '...' : balance}</span>
      </div>
    </div>
  );
};

export default CreditBalance;
